import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  options: {
    label: ReactNode;
    value: string;
  }[];
};

const RHFSelect = ({ name, label, placeholder, options = [] }: Props) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl fullWidth error={!!errors[name]}>
      {label && (
        <FormLabel
          sx={(theme) => ({
            mb: 0.75,
            color: theme.palette.primary.main,
            fontSize: "14px",
            "&.Mui-error": {
              color: theme.palette.primary.main,
            },
          })}
        >
          {t(label)}
        </FormLabel>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            size="small"
            displayEmpty
            sx={{
              fontSize: "14px",
            }}
            renderValue={(selected) =>
              selected ? (
                options.find((o) => o.value === selected)?.label
              ) : (
                <span style={{ color: "#9e9e9e", fontSize: "14px" }}>
                  {t(placeholder || "select")}
                </span>
              )
            }
          >
            {options?.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{ fontSize: "14px" }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      <FormHelperText>
        {t((errors[name]?.message as string) || "")}
      </FormHelperText>
    </FormControl>
  );
};

export default RHFSelect;
